import React from "react";
import {
  BestTable,
  LightButton,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeaderWithTitleAndClose,
  PrimaryButton
} from "best-common-react";
import { inject, observer } from "mobx-react";

function DigitalTicketsIdsModal(props) {
  const { digitalTicketsIdsStore } = props.rootStore;

  const TicketColumns = [
    {
      name: "Ticket ID",
      key: "ticketId",
      sortable: false,
      width: 300
    },
    {
      name: "Status",
      key: "status",
      sortable: false,
      width: 125
    }
  ];
  if (!digitalTicketsIdsStore.request.digitalTicketDelivery) {
    return null;
  }
  const ticketIds = digitalTicketsIdsStore.request.digitalTicketDelivery.ticketIds;
  const status = digitalTicketsIdsStore.request.digitalTicketDelivery.status;
  const ticketIdData = ticketIds.map(t => {
    return { ticketId: t, status: status };
  });

  return (
    <Modal
      show={digitalTicketsIdsStore.showDigitalTicketsIdsModal}
      onClose={() => digitalTicketsIdsStore.setShowDigitalTicketsIdsModal(false)}
      size="lg"
      id="digital-tickets-ids-modal"
    >
      <ModalHeaderWithTitleAndClose
        title="Digital Ticket IDs"
        close={() => {
          digitalTicketsIdsStore.setShowDigitalTicketsIdsModal(false);
        }}
      />
      <ModalBody>
        <BestTable
          columns={TicketColumns}
          data={ticketIdData}
          rowDisabledKey="disabled"
          rowStylesGetter={(index, value) => {
            if (value?.disabled) {
              return { background: "#f5f7fa" };
            } else {
              return {};
            }
          }}
          selectAll={false}
          maxTableHeight={250}
        />
      </ModalBody>
      <ModalFooter>
        <div>
          <LightButton
            onClick={() => {
              digitalTicketsIdsStore.setShowDigitalTicketsIdsModal(false);
            }}
          >
            Close
          </LightButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default inject("rootStore")(observer(DigitalTicketsIdsModal));
